import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9qdrzx45t: FaireProductEntity = {
  token: "p_d9qdrzx45t",
  type: "product",
  name: "Round Irregular Acrylic Metal Bracelets DP25B571",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/9b70396f7b9d41f0dbdb6483643bef44b6534729b060bf5cf6588d81f360b20a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/825515aa537bdc271df401beb4406f39e7e55b143f24e682492fb9727509c8d4.jpeg",
    "https://cdn.faire.com/fastly/f454efb67f056d7a2cadfef70ef40d7f37466cac3945781a57192efdafc66de1.jpeg",
    "https://cdn.faire.com/fastly/ec7751b2e7591ac27d93068294bb8f268ddca87c97107a01beb93f1ad0a13ebd.jpeg",
    "https://cdn.faire.com/fastly/5dbfbe27808829458c3f062265dae96b3d5ec7f72ed41f7ef7e8f910b6568c01.jpeg",
    "https://cdn.faire.com/fastly/13c9046893316b90c7129a2445cf6b525dea4c9f85fc6c106fb13740c2b0a4b5.jpeg",
    "https://cdn.faire.com/fastly/a1f245da11046695fb95ce82ce336261be4921b2dd9c5aa327eb3b408d4d12b6.jpeg",
    "https://cdn.faire.com/fastly/ae066a4b6f606c8f1d085fe5c41fde93eae5ce94a96737ebfd4db1058a4b5b2a.jpeg",
    "https://cdn.faire.com/fastly/fad2875bb32444407038813e5cd958caaa1c74f930ead8ba14c2efa8bf5eb7a1.jpeg",
  ],
  priceDollars: 5.53,
  description:
    "Feature:\n * Irregular \n * Layered Wear\n * Marbling Patterns\n * Smooth Surface\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 70g\n\n Material:\n * Acrylic\n\n Package:\n * Package include 1 bracelet.\n\n Note:\n * Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n * Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product.",
  tags: [],
  msrpDollars: 11.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:31.952Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
